import React from "react";
import Link from "next/link";
import CategorySubcategory from "@/components/Faq/FAQCategorySubcategory";

interface SectionCategoryProps {
    title: string;
    slug: string;
    iconUrl: string;
    index: number;
    totalPerRow: number;
    categories: {
        _id: string;
        title: string;
        slug: string;
        faqs: {
            _id: string;
            question: string;
            answer: string;
            slug: string;
        }[];
    }[];
}

const SectionCategory: React.FC<SectionCategoryProps> = ({
                                                             title,
                                                             slug,
                                                             iconUrl,
                                                             categories,
    index,
    totalPerRow,
                                                         }) => {

    const isLastInRow = (index + 1) % totalPerRow === 0; // Verifica se è l'ultimo nella riga
    //const isFirstInRow = index % totalPerRow === 0; // Verifica se è il primo nella riga

    return (
        <div className="w-full px-4 mb-8 lg:mb-0">
            {/*ICONA CON TITOLO SEZIONE*/}
            <div className="flex flex-col items-center space-y-3">
                <div className="relative w-full flex justify-center">
                    <Link hrefLang="it" title={title} href={`/faq/${slug}`}  className="size-16 flex justify-center items-center border border-border border-solid rounded-full">
                            <img src={iconUrl} alt={title} className="h-8 w-8 text-primary"/>
                    </Link>
                    {!isLastInRow && (
                        <div
                            data-orientation="horizontal"
                            role="none"
                            className="shrink-0 bg-border h-[1px] absolute top-1/2 -translate-y-1/2 -right-1/4 w-[calc(50%_-_64px)]">
                        </div>
                    )}
                </div>
                <p className="text-base font-bold lg:text-xl text-center ">{title}</p>
            </div>

            {/*LISTA CATEGORIE*/}
            <div>
                {categories.map((category) => (
                    <CategorySubcategory
                        key={category._id}
                        title={category.title}
                        slug={category.slug}
                        slugSezione={slug}
                        faqs={category.faqs}
                    />
                ))}
            </div>
        </div>
    );
};

export default SectionCategory;
